<button
  [attr.type]="type"
  [ngClass]="buttonClasses"
  [disabled]="isDisabled"
  [attr.aria-label]="ariaLabel"
  [attr.aria-expanded]="ariaExpanded"
  [attr.title]="resolvedTitle"
  [attr.aria-busy]="loading ? true : null"
  (click)="onClick($event)">
  <span
    class="portal-button__spinner spinner-border spinner-border-sm"
    *ngIf="loading"
    aria-hidden="true"></span>
  <span
    class="portal-button__content"
    [class.portal-button__content--hidden]="loading && isIconOnly">
    <i
      *ngIf="resolvedIconClass"
      class="portal-button__icon"
      [ngClass]="resolvedIconClass"
      aria-hidden="true"></i>
    <ng-content></ng-content>
  </span>
</button>
